import Vue from 'vue'
import Router, {Route} from 'vue-router'
import Template from './views/Template.vue'
import Dashboard from './views/Dashboard.vue'
import StatsTemplate from './views/StatsTemplate.vue'
import StatsGeneralChart from './views/elements/StatsGeneralChart.vue'
import StatsDetails from './views/elements/StatsDetails.vue'
import StatsDetailsDeklaracje from './views/elements/StatsDetailsDeklaracje.vue'
import StatsUruchomieniaTable from './views/elements/StatsUruchomieniaTable.vue'
import StatsPobraniaTable from './views/elements/StatsPobraniaTable.vue'
import StatsDeklaracjeTable from './views/elements/StatsDeklaracjeTable.vue'
import SignIn from './views/SignIn.vue'
import { TokenService } from './services/storage.service'
import NProgress from 'nprogress'
import store from './store'
import { changeFilterProductsToPitOnly } from "@/store/modules/settings/mutations";

Vue.use(Router)


const checkAllSettingsLoaded = (to: Route, from: Route, next: any) => {

  function proceed () {
    if (store.state.SettingsModule.allSettingsComplete) {
      next()
    }
  }
  if (!store.state.SettingsModule.allSettingsComplete) {
    store.watch(
        (state) => state.SettingsModule.allSettingsComplete,
        (value) => {
          if (value === true) {
            proceed()
          }
        }
    )
  }
  else {
    proceed()
  }
}



const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Template,
      beforeEnter: checkAllSettingsLoaded,
      children: [
        {
          path: '',
          name: 'dashboard',
          component: Dashboard
        },

        {
          path: 'stats-uruchomienia',
          component: StatsTemplate,
          children: [
            {
              path: '',
              name: 'stats-uruchomienia-index',
              component: StatsGeneralChart
            },
            {
              path: 'product/:id',
              name: 'stats-uruchomienia-product',
              component: StatsUruchomieniaTable,
              meta: {
                onlyOneProductAvailable: true
              }
            }
          ]
        },

        {
          path: 'stats-uruchomienia-details',
          component: StatsTemplate,
          children: [
            {
              path: ':id?',
              name: 'stats-uruchomienia-details-index',
              component: StatsDetails,
              meta: {
                onlyOneProductAvailable: true
              }
            }
           ]
        },

        {
          path: 'stats-pobrania',
          component: StatsTemplate,
          children: [
            {
              path: '',
              name: 'stats-pobrania-index',
              component: StatsGeneralChart
            },
            {
              path: 'product/:id',
              name: 'stats-pobrania-product',
              component: StatsPobraniaTable,
              meta: {
                onlyOneProductAvailable: true
              }
            }
          ],
          meta: {
            filterProductsToPitOnly: true
          }
        },

        {
          path: 'stats-pobrania-details',
          component: StatsTemplate,
          children: [
            {
              path: ':id?',
              name: 'stats-pobrania-details-index',
              component: StatsDetails,
              meta: {
                onlyOneProductAvailable: true
              }
            }
          ]
        },

        {
          path: 'stats-deklaracje',
          component: StatsTemplate,
          children: [
            {
              path: '',
              name: 'stats-deklaracje-index',
              component: StatsGeneralChart
            },
            {
              path: 'product/:id',
              name: 'stats-deklaracje-product',
              component: StatsDeklaracjeTable,
              meta: {
                onlyOneProductAvailable: true
              }
            }
          ]
        },

        {
          path: 'stats-deklaracje-details',
          component: StatsTemplate,
          children: [
            {
              path: ':id?',
              name: 'stats-deklaracje-details-index',
              component: StatsDetailsDeklaracje,
              meta: {
                onlyOneProductAvailable: true
              }
            }
          ]
        },

      ]
    },
    {
        path: '/login',
        name: 'login',
        component: SignIn,
        meta: {
          public: true,
          onlyWhenLoggedOut: true
        }
    }
    //,
    // ToDo: use webpackChunkName
    //{
      //path: '/about',
      //name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    //}
  ]
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const onlyOneProductAvailable = to.matched.some(record => record.meta.onlyOneProductAvailable)
  const filterProductsToPitOnly = to.matched.some(record => record.meta.filterProductsToPitOnly)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  //change onlyOneProductAvailable
  if (onlyOneProductAvailable != store.state.SettingsModule.onlyOneProductAvailable) {
    store.commit('SettingsModule/changeOnlyOneProductAvailable', onlyOneProductAvailable);
  }

  //changeFilterProductsToPitOnly to display only "pit" type products for particular routes
  if (filterProductsToPitOnly != store.state.SettingsModule.filterProductsToPitOnly) {
    store.commit('SettingsModule/changeFilterProductsToPitOnly', filterProductsToPitOnly);
  }



  next();
})


export default router;
